module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AlignLeft_16"],"path":[{"$":{"d":"M14,10v3H5V10h9m1-1H4v5H15V9ZM12,2H4V7h8ZM3,0H1V16H3Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AlignLeft_16.svg
// module id = IJZi
// module chunks = 1